/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import axios from 'axios'
import {Component, Vue} from 'vue-property-decorator'
import ForgotPassword from '@/components/user/ForgotPassword'
import {Getter, Mutation} from 'vuex-class'
import Login from '@/components/user/Login'
import UserServiceMixin from '@/services/UserServiceMixin'
import {UserService} from '@/services/UserService'

@Component({
    components: {
        Login,
        ForgotPassword,
    },
    mixins: [UserServiceMixin],
})

export default class Start extends Vue {
    @Getter('getStoreMessage') private storeMessage: string
    @Mutation('resetStoreMessage') private resetStoreMessage: any
    @Mutation('resetCurrentUser') private resetCurrentUser: any

    private userService: UserService
    private message = ''

    public async created() {

        if (this.storeMessage !== '') {
            // display store message coming from Home view and children (e.g. used by ChangePassword)
            this.setMessage(this.storeMessage)
        }
        this.resetStore()

        // post a logout to server, whatever the way we arrived to login page
        await this.userService.logout()

        axios.interceptors.response.use(
            (ok) => {
                return Promise.resolve(ok)
            },

            (err) => {
                if (err.response && err.response.status === 401
                    && err.config && !err.config.__isRetryRequest) {
                    this.$router.push({path: '/'})
                }
                return Promise.reject(err)
            })

    }

    private setMessage(message: string) {
        this.message = message
    }

    private resetStore() {
        this.resetCurrentUser()
        this.resetStoreMessage()
    }
}
